import { Checkbox, Col, Row } from "antd";

import React, { useState, useContext, useEffect } from "react";
import { useTheme } from "../../../Styles/ThemeHook";
import { IC_Collapse } from "shared-components/Components/Collapse/web";
import ButtonGroup from "../ButtonGroup/web";
import {
	bedrooms,
} from "../../../ViewFragments/SearchResults/Sider/TopBarFilters/options"
import { Switch } from "src/Components/Swicth/web";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { firstLetterToUppercase } from "src/utils/Functions";
import { useFilters } from "../Filters.hook";

export const Bedrooms = ({ collapsable = false, inputType = "checkbox", filterChanged, triggerApplyFilter = undefined, show = false }) => {
	if (!show) return null;

	const { filters } = useFilters();
	const { theme } = useTheme();
	const { translations, country_code } = useContext(ConfigStateContext);
	let filter = null
	const [usingExactMode, setUsingExactMode] = useState<boolean>(filters?.bedroomsExactMode ?? false);
	const [currentValue, setCurrentValue] = useState(filters?.bedrooms ?? []);
	const [bedroomsOptions, setBedroomsOptions] = useState([]);

	const normalizeFilterValues = (values) => {
		if (!Array.isArray(values)) return [];
		return values
			.map(item => (item && typeof item === "object" ? item.value : item))
			.filter(item => item !== undefined && item !== null);
	};

	const arraysAreEqual = (first = [], second = []) => {
		if (first === second) return true;
		if (first.length !== second.length) return false;
		return first.every((item, index) => second[index] === item);
	};

	useEffect(() => {
		const bedroomsValue = normalizeFilterValues(filters?.bedrooms);
		const normalizedCurrent = normalizeFilterValues(currentValue);

		if (!arraysAreEqual(bedroomsValue, normalizedCurrent)) {
			setCurrentValue(bedroomsValue);
		}

		if (filters?.bedroomsExactMode !== undefined &&
			filters?.bedroomsExactMode !== usingExactMode) {
			setUsingExactMode(filters?.bedroomsExactMode);
		}
	}, [filters?.bedrooms, filters?.bedroomsExactMode]);

	useEffect(() => {
		if (country_code) {
			const bedroomsByCountry = bedrooms.filter((bedroom) => bedroom.countries.includes(country_code))
			setBedroomsOptions(bedroomsByCountry)
		}
	}, [country_code])

	const handleChange = (value) => {
		const rawValues = Array.isArray(value)
			? value
			: value === undefined || value === null
				? []
				: [value];
		const sanitizedValues = rawValues.filter(item => item !== undefined && item !== null);

		if (sanitizedValues.length === 0) {
			handleClearFilter();
			return;
		}

		const valueSet = new Set(sanitizedValues.map(item => String(item)));
		const selectedOptions = bedroomsOptions.filter(option => valueSet.has(String(option.value)));

		if (selectedOptions.length === 0) {
			handleClearFilter();
			return;
		}

		const selectedValues = selectedOptions.map(option => option.value);
		const dataOptions = selectedOptions.map(option => ({
			text: usingExactMode ? option.text : option.text.replace(/dormitorios/, "o más dormitorios"),
			value: option.value
		}));

		setCurrentValue(selectedValues);
		handleApplyFilter({ bedrooms: dataOptions, bedroomsExactMode: { text: null, value: usingExactMode } });
	};

	const handleClearFilter = () => {

		setCurrentValue([]);

		if (currentValue.length === 0 && usingExactMode === false) {
			handleApplyFilter({ bedrooms: [], bedroomsExactMode: { text: null, value: false } });
			return;
		}
		handleApplyFilter({ bedrooms: [], bedroomsExactMode: { text: null, value: false } });

	};

	const handleExactChange = (value) => {
		setUsingExactMode(value);
		handleApplyFilter({ bedroomsExactMode: { text: null, value } });

		if (!value) {
			handleClearFilter();
		}
	}

	const handleApplyFilter = (filter) => {
		if (triggerApplyFilter) triggerApplyFilter(filter);
		else filterChanged(filter)
	}

	if (inputType === "checkbox") {
		filter = (
			<Checkbox.Group value={currentValue} onChange={handleChange}>
				<Row gutter={[0, theme.spacing.lgSpacing]}>
					{bedroomsOptions?.map(option => {
						return (
							<Col span={24} key={`key_${option.value}_bedroom`}>
								<Checkbox value={option.value}>
									{option.text}
								</Checkbox>
							</Col>
						);
					})}
				</Row>
			</Checkbox.Group>
		);
	} else if (inputType === "buttonGroup") {
		filter = (
			<>
				<div className="filter__scrollable-box">
					<ButtonGroup
						options={bedroomsOptions.map(option => { return { text: option.smallText, value: option.value } })}
						selected={currentValue}
						allowMuliple={usingExactMode}
						onChange={handleChange}
						cleanFilter={handleClearFilter}
						optionForAny={{ text: 'Todos', value: null }}
						exactMode={usingExactMode}
					/>
				</div>

				<div className="filter__exact-mode">
					<span>Número exacto de {translations.habitaciones}</span>
					<Switch checked={usingExactMode} onChange={handleExactChange} />
				</div>

				<hr style={{ width: "100%", border: 'none', borderTop: '1px solid rgba(0,0,0,.06)', margin: '24px 0' }} />
			</>
		);
	}

	return (
		<div className={"filter bedroom-filter"}>
			{collapsable ?
				<IC_Collapse label={firstLetterToUppercase(translations.habitaciones)} isActive={currentValue?.length >= 1} startOpen={currentValue?.length >= 1}>
					{filter}
				</IC_Collapse> :
				<>
					{inputType === "buttonGroup" && <h3 className="filter-title">{firstLetterToUppercase(translations.habitaciones)}</h3>}
					{filter}
				</>
			}
		</div>
	);
};
